
import CustomTable from "../../../core/components/common/custom-table.component"
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CustomeStatusLabel from '../../../core/components/ui/custom-status-label.component'
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import RoleManagementService from "../../RoleManagmentPlugin/services/api/role-managment-service";
import CustomClickableLabel from "../../../core/components/ui/custom-clickable-label.component";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";

const AccessControlRoleList = ({setSelected, setRow}) => {

    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    const fetchData = () => {
        setLoading(true)
        RoleManagementService.getList().then((res) => {
            let apiResponse = res.data;
            console.log("apiResponse", apiResponse)
            setRows(apiResponse.data)

        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
        }).finally(() =>{
            setLoading(false)
        })
    };
          
    // run this function onPageLoad
    useEffect(() => {
        fetchData();
    }, []);

    // headers
    const headers = [
        {label: "Role Name"},
        {label: "Description"},
        {label: "Status"},
    ]

    const onClick = (row) => {
       setRow(row)
       setSelected(true)
    }


    return (
        <div>
            <CustomTable headers={headers}>
                {rows.map((row) => {    
                    return (
                    <TableRow key={row.id}>
                        <TableCell><CustomClickableLabel onClick={() => onClick(row)} >{row.role}</CustomClickableLabel></TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell><CustomeStatusLabel label={ row.active ? "Active":"Inactive" } /></TableCell>
                    </TableRow>
                    )
                })}
            </CustomTable>
            {loading && (
                <CustomListviewLoader/>
            )}
        </div>
    )
}

export default AccessControlRoleList